// these operations are used for undo/redo and keeping the embed player and share
// video control bar in sync
export const ADD_TRIM_OPERATION = 'add';
export const REMOVE_TRIM_OPERATION = 'remove';
export const UPDATE_TRIM_OPERATION = 'update';

// these are only used to keep the embed player and share video control bar in
// sync
export const ENTER_TRIM_MODE_OPERATION = 'enter';
export const LEAVE_TRIM_MODE_OPERATION = 'leave';
export const REDO_TRIM_OPERATION = 'redo';
export const UNDO_TRIM_OPERATION = 'undo';
export const UPDATE_SELECTED_TRIM_BOUND_OPERATION =
  'update-selected-trim-bound';
export const UPDATE_SELECTED_TRIM_RANGE_OPERATION =
  'update-selected-trim-range';
export const UPDATE_CURRENT_TRIM_RANGE_OPERATION = 'update-current-trim-range';

// 100ms as the minimum trim range length
export const MIN_TRIM_RANGE_LENGTH = 100;

// trim range bounds
export const TRIM_BOUND_DEACTIVATE_TIMEOUT = 3000;
export const TRIM_BOUND_LOWER = 'lower';
export const TRIM_BOUND_UPPER = 'upper';
